const getters = {
  list: state => state.walletList,
  isLoading: state => state.isLoading,
  isTransporterListLoading: state => state.isTransporterListLoading,
  transporterWallet: state => state.transporterWallet,
  hasEmpty: state => state.hasEmpty,
  page: state => state.page,
};

export default getters;
